import React, { useRef } from "react";
import axios from "axios";
import { useContext, useState, useEffect } from "react";
import { Link, useNavigate, useRevalidator } from "react-router-dom";
import PsContext from "../../context";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import Footer from "../footer";
import {
  groupByMultiple,
  lowerCase,
  MOB_ICONS,
  momentDate,
  queryParam,
  sleep,
  upperCase,
  useQuery,
} from "../../utils";
import { Toast, Dialog, List, SwipeAction } from "antd-mobile";
import { Button, Form } from "react-bootstrap";
import moment from "moment";

const SwipeScreen = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [longAbsentee, setLongAbsentee] = useState([]);

  const [markedStudents, setMarkedStudents] = useState([]);
  const [workDone, setWorkDone] = useState(null);
  const workDoneRef = useRef(null);

  let searchParams = queryParam(useQuery());
  let allowOd = context.settingValue("attendance_allow_od_by_staff") == "1";

  const stateField = (fieldName) => {
    return searchParams?.[fieldName];
  };

  const checkMarkedAttendaceStatus = (item) => {
    let m = props.markedData.find(
      (obj) => obj.student_uuid == item.uuid && obj.course == item.course
      //obj.day_value == item.day_value &&
      //obj.hour_value == item.hour_value &&
      //obj.semester == item.semester &&
      //obj.subject == item.subject &&
      //obj.teacher == item.teacher
    );
    return m;
  };

  const checkLongAbsentee = (uuid) => {
    /*let x = longAbsentee.findIndex((obj) => obj.student_uuid == uuid);
    return x > -1 ? true : false;*/
    return props.checkLongAbsentee(uuid);
  };

  const absendClick = (item, ltype = "a") => {
    if (props.absendClick) props.absendClick(item, ltype);
    /*let m = [...markedStudents];
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);

    if (index > -1) {
      let lt = m[index]["leave_type"];
      if (lt == ltype) m[index]["leave_type"] = "";
      else m[index]["leave_type"] = ltype;
      setMarkedStudents(m);
    }*/
  };

  const checkStudentMarked = (item) => {
    if (props.checkStudentMarked) return props.checkStudentMarked(item);
    /*
    let m = markedStudents;
    let index = m.findIndex((obj) => obj.student_uuid == item.uuid);
    return index > -1 && m[index]["leave_type"];*/
  };

  const swipeActionList = (item) => {
    if (checkLongAbsentee(item.uuid)) return [];

    if (
      !context.allowedAccess("mob_student_attendance", "action_update") &&
      props.markedData.length > 0
    )
      return [];

    let sta = checkStudentMarked(item);

    let rv = [];
    if (!props.allowAttendance) return rv;
    if (allowOd)
      rv.push({
        key: "od",
        text: "OD",
        color: "primary",
        onClick: () => absendClick(item, "od"),
      });

    if (
      context.allowedAccess("mob_student_attendance_leave", "action_create") ||
      context.allowedAccess("stu_attendance_l", "action_create")
    ) {
      rv.push({
        key: "l",
        text: "L",
        color: "danger",
        onClick: () => absendClick(item, "l"),
      });
    }

    rv.push({
      key: "ab",
      text: "AB",
      color: "danger",
      onClick: () => absendClick(item),
    });

    if (checkStudentMarked(item) != "p")
      rv.push({
        key: "p",
        text: "P",
        color: "success",
        onClick: () => absendClick(item, "p"),
      });
    return rv;
  };

  return (
    <>
      <List>
        {props.items.map((item, j) => {
          let sta = checkStudentMarked(item);
          return (
            <SwipeAction key={item.id} rightActions={swipeActionList(item)}>
              <List.Item
                extra={item.registerno || item.admissionno}
                className={
                  sta == "a" || sta == "la" || sta == "l"
                    ? "bg-red-50 text-danger"
                    : sta == "od"
                    ? "bg-blue-50 text-info"
                    : sta == "l"
                    ? "bg-silver-50 text-dark"
                    : null
                }
              >
                {item.name} {item.initial || ""}
                {checkLongAbsentee(item.uuid) && (
                  <span className="text-danger" style={{ fontSize: "10px" }}>
                    <br />
                    Long Absent
                  </span>
                )}
              </List.Item>
            </SwipeAction>
          );
        })}
      </List>
    </>
  );
};
export default SwipeScreen;
